import { THEME_TYPO_TOKEN } from '../constant';

import { aloha } from '@gojek/theme-asphalt-web-aloha';

export * from './dataUtils';
export { fetchRequest as default } from './fetchRequest';

export const getCustomTheme = () => {
  return { ...aloha, ...THEME_TYPO_TOKEN };
};

export const isGPMotion = (className: string) => className === 'GPMotion';
export const capitalizeFirst = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1);
